import { render, staticRenderFns } from "./BaseContinueButton.vue?vue&type=template&id=5bd0bb3a&scoped=true"
import script from "./BaseContinueButton.vue?vue&type=script&lang=js"
export * from "./BaseContinueButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd0bb3a",
  null
  
)

export default component.exports